import React from 'react';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
  NotificationsActive,
  TouchApp,
  ToggleOn,
} from '@mui/icons-material';

const mapStateToProps = () => ({});

const BENEFITS = [
  {
    icon: NotificationsActive,
    text:
      'Alerté immédiatement, sans avoir à ouvrir l\'application régulièrement',
  },
  {
    icon: TouchApp,
    text:
      'En appuyant sur la notification, vous arrivez directement' +
      ' sur la mission concernée',
  },
  {
    icon: ToggleOn,
    text:
      'Activez ou désactivez les notifications à tout moment' +
      ' depuis votre profil',
  },
];

const PushPermissionTeaser = () => (
  <Box>
    <Box
      component="img"
      src="/enable-notification.png"
      alt="Notifications"
      sx={{
        width: '100%',
        maxHeight: 180,
        objectFit: 'contain',
        display: 'block',
        mb: 2,
      }}
    />
    <Typography variant="h6" fontWeight="bold" gutterBottom>
      Ne manquez plus aucune mission !
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Activez les notifications pour recevoir vos nouvelles propositions
      en temps réel, même téléphone en veille.
    </Typography>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {BENEFITS.map(({ icon: Icon, text }) => (
        <Box
          key={text}
          sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}
        >
          <Icon color="primary" sx={{ flexShrink: 0 }} />
          <Typography variant="body2">{text}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
);

export default connect(mapStateToProps)(PushPermissionTeaser);
